import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useDispatch, useSelector } from 'react-redux';
import { actionGetDonation } from 'actions';
import { actionShopCartUpdatePopupCounts } from 'actions';
import { FormattedInputs } from '../../../components/InputControls';
import { makeStyles } from '@material-ui/styles';

const { DonationProductID, DonationHeading, DonationDetails, InvalidDOnationAmount } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    primarycolor: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    errorFont: {
        color: 'red'
    }
}));

export default function DonationPopUp(props) {

    const classes = useStyles();

    useEffect(() => {
        if (DonationProductID !== undefined) {
            actionGetDonation(dispatch, DonationProductID, 'donation');
        }
    }, []);

    const dispatch = useDispatch();
    const donations = useSelector(state => state.reducerDonation);
    const events = useSelector(state => state.reducerShopCart.events);
    const donation = useSelector(state => state.reducerShopCart.donation);
    const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);
    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const gatickets = useSelector(state => state.reducerShopCart.GATickets);
    const giftcards = useSelector(state => state.reducerGiftCards);

    const [open, setOpen] = React.useState(false);
    const [showOthers, setshowOthers] = React.useState(false);
    const [donationPrice, setdonationPrice] = React.useState(0);
    const [productName, setproductName] = React.useState('');
    const [errorMsg, seterrorMsg] = React.useState('');

    const ShowGiftCards = () => {
        let res = false;
        if (giftcards.giftcards && giftcards.giftcards.length > 0) {
            if (giftcards.giftcards.filter(x => x.AddedToCart === true).length > 0) {
                res = true;
            }
        }

        return res;
    }

    if (props.showDialog && open === false && ((events && events.length > 0) || (gatickets && gatickets.length > 0) || (membershipPackages && membershipPackages.length > 0) || (donationProducts && donationProducts.length > 0) || ShowGiftCards()) && donation.popupCounts === 0 && donationProducts.length == 0) {
        setOpen(true);
        actionShopCartUpdatePopupCounts(dispatch)
    }

    const Validated = (val) => {
        if (val)
            seterrorMsg('');
        else
            seterrorMsg(InvalidDOnationAmount);
    }

    const ApplyDonation = () => {

        if (donationPrice === "" || donationPrice === 0 || donationPrice < 0.1) {
            Validated(false);
            return;
        }

        if (errorMsg !== '' && errorMsg.length > 0) {
            return;
        }

        props.ApplyDonation(DonationProductID, productName, donationPrice, showOthers ? true : false);
        props.CloseDonationPopUp();
        setOpen(false);
    }

    const handleClose = () => {
        props.CloseDonationPopUp();
        setOpen(false);
        Validated(true);
    };

    const handleChange = (event) => {

        if (event.target.value === "Other") {
            setdonationPrice('');
            setshowOthers(true)
        }
        else {
            setshowOthers(false);
            setdonationPrice(event.target.value);
            setproductName(event.target.name);
            Validated(true);
        }
    };

    const handleOtherPrice = (event) => {
        setdonationPrice(event.target.value);
        setproductName(event.target.name);
    }

    return (
        <div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{DonationHeading}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {DonationDetails}
                    </DialogContentText>
                    <DialogContentText className={classes.errorFont}>
                        {errorMsg}
                    </DialogContentText>
                    <RadioGroup aria-label="donations" name="donationspop" >

                        {donations.donations !== "nocontent" && donations.donations.length > 0 ?
                            donations.donations.map((dona, i) => {

                                return dona.Price > 0 ?

                                    dona.hasOwnProperty("MaxPrice") ?
                                        <div className={'MuiFormControlLabel-root'} key={donations}>
                                            <FormControlLabel key={i} value="Other" control={<Radio />} label="Other" onChange={handleChange} />
                                            {showOthers ?
                                                <FormattedInputs
                                                    minValue={dona.Price}
                                                    maxValue={dona.MaxPrice}
                                                    productName={dona.ProductName}
                                                    handleOtherPrice={handleOtherPrice}
                                                    Validated={Validated}
                                                    keyVal={i}
                                                ></FormattedInputs> : null}

                                        </div>
                                        :
                                        <FormControlLabel key={i} value={dona.Price.toString()} name={dona.ProductName} control={<Radio />} label={'$' + dona.Price} onChange={handleChange} />

                                    : null
                            }) : null}

                    </RadioGroup>
                </DialogContent>
                <DialogActions>

                    <Button onClick={ApplyDonation} variant="contained" size="medium" color="primary" >
                        Donate
                    </Button>
                    <Button onClick={handleClose} variant="contained" size="medium" color="primary" >
                        No Thanks
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
